"use client";

import { useEffect, useState } from "react";

const START_AT = new Date("2026-03-05T18:00:00+01:00").getTime();
const END_AT = new Date("2026-03-12T12:00:00+01:00").getTime();

const isInWindow = () => {
  const now = Date.now();
  return now >= START_AT && now < END_AT;
};

export const BookingMaintenanceNotice = () => {
  const [isVisible, setIsVisible] = useState(isInWindow);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIsVisible(isInWindow());
    }, 60_000);

    return () => {
      window.clearInterval(timer);
    };
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="my-6 rounded-md bg-red-700 px-4 py-3 text-sm font-medium leading-relaxed text-white">
      Unser Online-Buchungssystem ist vom 09.03. 18.00 Uhr bis 12.03. 12:00 Uhr
      nicht verfügbar. Wenden Sie sich direkt an unsere Campingparks. In der
      Zeit sind verbindliche Buchungsbestätigungen jedoch nicht möglich.
    </div>
  );
};
